import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { FavoriteInformerPageInterface } from '@zaoblako/shared/modules/notification/dtos/informer/favorite-informer-page.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FavoriteInformerService extends BaseService {
  protected baseUrl = '/basis/notification/favorite-informer';

  public getExpiredObjects(options: PaginationQueryInterface): Observable<FavoriteInformerPageInterface> {
    return this.http.get<FavoriteInformerPageInterface>(this.baseUrl, {
      params: options ? this.objectToHttpParams(options) : {}
    });
  }
}
